class TestNotesController {
    constructor($timeout, $confirm, TestNotesServiceApi, TraceDetailsServiceApi, WaiverServiceApi, UserDetailsApi, AttachmentsService, ScriptInjectionService, toastr) {
        // Used because $onChanges can fire before $onInit
        this.isInitialized = false;
        this.$onInit = () => {
            if (!this.isInitialized) {
                this.UserDetailsApi.get().then((response) => {
                    this.user = response.data;
                });
                this.notifySupport = false;
                this.isInitialized = true;
            }
        };
        this.$onChanges = (changes) => {
            // Make sure we're initialized
            this.$onInit();
            if (changes.notes) {
                this.notes = angular.copy(changes.notes.currentValue);
                if (this.notes.length > 0) {
                    this.showNotes = true;
                }
            }
            if (changes.selectedItems) {
                this.selectedItems = angular.copy(changes.selectedItems.currentValue);
            }
        };
        this.isToday = (dt) => {
            let today = moment();
            let diff = today.diff(dt, 'days');
            return diff === 0;
        };
        this.saveNote = (noteText) => {
            if (!noteText) {
                this.toastr.warning('Please enter some text for the note.');
                return;
            }
            if (this.ScriptInjectionService.isInjectedScript(noteText)) {
                this.toastr.error('Note Text contains illegal characters');
                return;
            }
            // Prevent double hit on saveNote
            this.showNote = false;
            // Save the new note
            let saveNoteRequest = {
                NoteText: noteText,
                UserId: this.selectedItems.selectedTester.Id,
                ProjectIterationId: this.selectedItems.projectIterationId,
                SimId: this.selectedItems.selectedSim.Id,
                SuiteId: this.selectedItems.selectedSuite.Id,
                TestId: this.selectedItems.selectedTest.Id,
                CreatedBy: 0,
                TraceUid: '',
                NotifySupport: this.notifySupport
            };
            this.TraceDetailsServiceApi.saveNote(saveNoteRequest).then(() => {
                // SignalR will render the note for us
                this.newNote = '';
            });
        };
        this.showNoteTextArea = () => {
            // Show the existing notes along with the note entry text area
            this.showNote = true;
            this.showNotes = true;
            // Now set focus
            this.timeout(() => {
                document.getElementById('noteTextArea').focus();
            });
        };
        this.getFromNowString = (utcTime) => {
            let utc = moment.utc(utcTime);
            let local = moment(utc).local();
            return moment(local).fromNow();
        };
        this.deleteNote = (note) => {
            let title = `Delete Note`;
            let text = `Are you sure you want to delete this note?`;
            this.confirm({ title, text }, {}).then(() => {
                this.deleteMedia(note);
            });
        };
        this.deleteMedia = (media) => {
            let attachmentsRequest = {
                UserId: this.selectedItems.selectedTester.Id,
                SimId: this.selectedItems.selectedSim.Id,
                SuiteId: this.selectedItems.selectedSuite.Id,
                TestId: this.selectedItems.selectedTest.Id,
                WithFileContents: false
            };
            this.TraceDetailsServiceApi.deleteAttachment(media.Id, attachmentsRequest).then((response) => {
                // TODO: Repoulate the notes or just delete the existing note
                let attachmentsDto = response.data;
                this.attachments = attachmentsDto;
                this.notes = this.attachments.Notes;
                this.toastr.info('Note deleted');
            });
        };
        this.timeout = $timeout;
        this.confirm = $confirm;
        this.TestNotesServiceApi = TestNotesServiceApi;
        this.TraceDetailsServiceApi = TraceDetailsServiceApi;
        this.WaiverServiceApi = WaiverServiceApi;
        this.UserDetailsApi = UserDetailsApi;
        this.AttachmentsService = AttachmentsService;
        this.ScriptInjectionService = ScriptInjectionService;
        this.toastr = toastr;
    }
}
angular.module('app').component('testNotes', {
    bindings: {
        notes: '<', // AttachmentModel[]
        selectedItems: '=' // selectedItemsModel
    },
    templateUrl: 'scripts/app/partials/TraceDetails/TestNotes/test-notes.tpl.html',
    controllerAs: 'vm',
    controller: TestNotesController
});
